import React from "react";
import FormattedDate from "./FormattedDate";
import WeatherIcon from "./WeatherIcon";

export default function WeatherInfo(props) {
  return (
    <div className="WeatherInfo">
      <h1>{props.data.city}</h1>
      <div className="row mt-3">
        <div className="col-6">
          <div className="clearfix">
            <div className="float-left">
              <WeatherIcon code={props.data.icon} size={60} />
            </div>
            <div className="currentTemperature">
              {Math.round(props.data.temperature)}°
            </div>
            <div className="currentWeather">
              <ul>
                <li className="text-capitalize">{props.data.description}</li>
                <li>Humidity: {props.data.humidity}%</li>
              </ul>
            </div>
          </div>
        </div>
        <div className="col-6">
          <ul>
            <li>
              <FormattedDate date={props.data.date} />
            </li>

            <li>Wind: {props.data.wind} km/h</li>
          </ul>
        </div>
      </div>
    </div>
  );
}
